import AppBar from "@components/AppBar";
import InteractiveChat from "@components/InteractiveChat";
import { InputContext } from "@context/Input/InputContext";
import { useHeaderHeight } from "@hooks/useHeaderHeight";
import LayoutDefault from "@layouts/LayoutDefault";
import { Box, useTheme } from "@mui/material";
import React from "react";
import { useSearchParams } from "react-router-dom";

const MainView = () => {
  const inputCtx = React.useContext(InputContext);
  const [searchParams] = useSearchParams();
  const threadId = searchParams.get("thread_id") || undefined;
  const theme = useTheme();

  const headerHeight = useHeaderHeight();

  return (
    <LayoutDefault title="diari-ara">
      <Box
        sx={{
          display: "flex",
          width: "100%",
          height: "100%",
          backgroundColor: theme.palette.background.paper,
          backgroundSize: "cover",
          backgroundPosition: "center",
          // Add padding top to account for fixed AppBar
          pt: {
            xs: headerHeight.mobile,
            sm: headerHeight.desktop
          }
        }}
      >
        <Box
          width={"100%"}
          sx={{ display: "flex", flexDirection: "column", height: "100%" }}
        >
          <AppBar />

          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
              pt: 2,
              px: 2,
              bgcolor: theme.palette.background.paper
            }}
          >
            <Box
              sx={{
                p: { xs: 0, md: 2 },
                width: "100%",
                height: "100%",
                maxWidth: { xs: "100%", md: 1024 }
              }}
            >
              <InteractiveChat
                initialMessage={inputCtx?.initialMessage}
                initialMessageDisplay={inputCtx?.initialMessageDisplay}
                initialMessageBackend={inputCtx?.initialMessageBackend}
                initialAudio={inputCtx?.initialAudio}
                threadId={threadId}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </LayoutDefault>
  );
};

export default MainView;
